module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo11-9c5fd1d52c499cb14f9f42470703a5ee.jpg";